<template>
    <div class="wrapper blog-posts">
        <div class="page-header page-header-small signup-page section-image">
            <parallax class="page-header-image" style="background-image: url('img/homepage/freeCompetionsHero.jpg') ;">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">Free Competitions</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="container">
                <div class="section">
                    <!-- <h3 class="title text-center">You may also be interested in</h3> -->
                    <br/>

                <div class="row">
                    <div class="col-md-8">

                <!-- Content of Review -->
                <div  v-for='freeCompetion in freeCompetions' :key="freeCompetion.id">
                    <h3 class="card-title">
                        <a :href="freeCompetion.link" target="_blank">{{freeCompetion.title}}</a>
                    </h3>
                    <!-- <p>{{freeCompetion.content}}</p> -->
                    
                      <div v-html="freeCompetion.content" />
                    
                    
                </div>


                <!-- End Content of Review -->



                    </div>
                   <!-- SIDEBAR BEGINS -->
                    <div class="col-md-4">
                       <sidebar></sidebar>
                    </div>
                    <!-- SIDEBAR ENDS -->
                </div>                    

                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput } from '@/components';
  import { Carousel, CarouselItem, Table, TableColumn } from 'element-ui'
  import Sidebar from '@/pages/bet/sidebar';
  import db from '../../components/Firebase/firebaseInit'
  
  export default {
    name: 'blog-posts',
    bodyClass: 'blog-posts',
    components: {
      Card,
      Sidebar,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        year: new Date().getFullYear(),
        freeCompetions: []
      }
    },
    created(){
    db.collection('freeCompetions').get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id': doc.id,
          'title': doc.data().title,
          'content': doc.data().content,
          'link': doc.data().link
        }
        this.freeCompetions.push(data)
      })
    })
    }
  }
</script>
<style>
</style>
